export interface AbstractTestimonyFormValue {
  content: string;
  ecnRank: string;
}

export abstract class AbstractTestimonyPayload {
  content: string;
  ecnRank: string;

  constructor(formValue: Partial<AbstractTestimonyFormValue>) {
    this.content = formValue.content;
    this.ecnRank = formValue.ecnRank;
  }
}
